import { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';
import EventEmitter from '../../utils/EventEmitter';

export type NotificationType = 'info' | 'warning' | 'success' | 'error';

export const NOTIFICATION_TYPE = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error',
};

export type NotificationDuration = 'slow' | 'normal' | 'fast' | 'static';

export const NOTIFICATION_DURATION = {
  SLOW: 'slow',
  NORMAL: 'normal',
  FAST: 'fast',
  STATIC: 'static',
};

export interface Notification {
  type: NotificationType;
  title?: string | ReactNode;
  message: string | ReactNode;
  duration?: NotificationDuration;
}

export interface InternalNotification extends Notification {
  id: string;
  created: number;
}

export const NOTIFY_EVENT = 'NOTIFY_EVENT';

const notificationFactory = (
  notification: Notification
): InternalNotification => ({
  id: uuid(),
  created: new Date().getTime(),
  duration: notification.duration || 'normal',
  type: notification.type,
  title: notification.title,
  message: notification.message,
});

class NotificationEmitter extends EventEmitter {
  notify = (notification: Notification) => {
    this.publish({
      name: NOTIFY_EVENT,
      payload: notificationFactory(notification),
    });
  };

  addListener = (callbackFn: Function) => {
    this.subscribe(NOTIFY_EVENT, callbackFn);
  };

  removeListener = (callbackFn: Function) => {
    this.unsubscribe(NOTIFY_EVENT, callbackFn);
  };
}

export const NotificationManager = new NotificationEmitter();
